// Bootstrap Tooltip Helper

function initializeTooltips(toolTipsConfig) {
    let configs = [];

    if (typeof toolTipsConfig === 'string') {
        configs = [[toolTipsConfig]];
    } else if (Array.isArray(toolTipsConfig)) {
        if (
            toolTipsConfig.length === 2 &&
            typeof toolTipsConfig[0] === 'string' &&
            typeof toolTipsConfig[1] === 'object')
        {
            configs = [[toolTipsConfig[0], toolTipsConfig[1]]];
        }
        else if (toolTipsConfig.every(item => Array.isArray(item))) {
            configs = toolTipsConfig;
        }
        else {
            configs = toolTipsConfig.map(sel => [sel]);
        }
    }

    configs.forEach(([selector, options]) => {
        document.querySelectorAll(selector).forEach(function(el) {
            new bootstrap.Tooltip(el, options || {});
            el.addEventListener('show.bs.tooltip', function(e) { e.stopPropagation(); });
            el.addEventListener('hide.bs.tooltip', function(e) { e.stopPropagation(); });
        });
    });
}

// If using modules, export. Otherwise, attach to window for global use.
if (typeof window !== 'undefined') {
    window.initializeTooltips = initializeTooltips;
}
